/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsExceptionListItem
 */
export interface EfsMelcoEfsModelsExceptionListItem {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsExceptionListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsExceptionListItem
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsExceptionListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsExceptionListItem
     */
    desc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsExceptionListItem
     */
    value1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsExceptionListItem
     */
    value2?: string | null;
}

export function EfsMelcoEfsModelsExceptionListItemFromJSON(json: any): EfsMelcoEfsModelsExceptionListItem {
    return EfsMelcoEfsModelsExceptionListItemFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsExceptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsExceptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
        'value1': !exists(json, 'value1') ? undefined : json['value1'],
        'value2': !exists(json, 'value2') ? undefined : json['value2'],
    };
}

export function EfsMelcoEfsModelsExceptionListItemToJSON(value?: EfsMelcoEfsModelsExceptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'desc': value.desc,
        'value1': value.value1,
        'value2': value.value2,
    };
}


